module.exports = __webpack_public_path__ + "static/fcra-2018-19-q3-30508a565a5f576022f75d0bf290647f.pdf";